(() => {
  document.documentElement.dataset.motionAssets = "20260612-static-fallback";

  const recoverBrokenHomeShell = () => {
    const rawPath = window.location.pathname;
    const normalizedPath = rawPath.replace(/\/$/, "");
    const isStorefrontHome = normalizedPath === "" || normalizedPath === "/en-canada";
    const isLegacySiloPage = normalizedPath === "/silo" || normalizedPath === "/en-canada/silo";
    const storefrontRoot = normalizedPath.startsWith("/en-canada") ? "/en-canada/" : "/";

    const redirectToStorefrontRoot = () => {
      const target = new URL(storefrontRoot, window.location.origin);
      new URLSearchParams(window.location.search).forEach((value, key) => {
        if (!key.startsWith("cns_")) target.searchParams.set(key, value);
      });
      target.searchParams.set("cns_home_recover", String(Date.now()));
      window.location.replace(target.toString());
    };

    const loadStaticHomeFallback = () => {
      if (window.__cnsHomeShellRecovery === true) return;
      window.__cnsHomeShellRecovery = true;

      const currentScript =
        document.currentScript ||
        Array.from(document.scripts).find((script) => /\/theme\.js(?:\?|$)/.test(script.src));
      const assetBase = currentScript && currentScript.src
        ? currentScript.src.replace(/theme\.js(?:\?.*)?$/, "")
        : `${window.location.origin}/cdn/shop/t/18/assets/`;

      const fallbackScript = document.createElement("script");
      fallbackScript.async = true;
      fallbackScript.src = `${assetBase}cns-home-fallback.js?cns_static_home=${Date.now()}`;
      fallbackScript.onerror = () => {
        if (rawPath !== storefrontRoot) redirectToStorefrontRoot();
      };
      document.head.appendChild(fallbackScript);
    };

    if (isLegacySiloPage) {
      redirectToStorefrontRoot();
      return;
    }

    if (!isStorefrontHome || document.querySelector(".hero.home-section, .routine-pairing-band, .authority-card")) return;

    const pageHero = document.querySelector(".page-hero");
    const looksLikeEmptyHomeShell =
      pageHero &&
      /Canada Nano Silver/i.test(pageHero.textContent || "") &&
      !document.querySelector(".hero.home-section, .routine-pairing-band, .authority-card");

    if (!looksLikeEmptyHomeShell) return;
    loadStaticHomeFallback();
  };

  recoverBrokenHomeShell();
  document.addEventListener("DOMContentLoaded", recoverBrokenHomeShell);
  window.addEventListener("load", recoverBrokenHomeShell);

  const isHomepagePath = () => {
    const path = window.location.pathname.replace(/\/$/, "");
    return path === "" || path === "/en-canada";
  };

  const normalizeHomepage = () => {
    if (!isHomepagePath()) return;

    document.querySelectorAll(".video-intro-card p").forEach((node) => {
      if (node.textContent.includes("complete routines")) {
        node.textContent = "Start with product highlights, then browse World-Wide Shipping products, balanced categories, and local retail options.";
      }
    });

    document.querySelectorAll(".routine-nav-band").forEach((section) => {
      if (section.textContent.includes("Purchase a complete routine")) {
        section.remove();
      }
    });

    document.querySelectorAll("section, .shopify-section, .section").forEach((section) => {
      if (/UGC TUTORIALS|Watch How To Use Our Best Sellers|TUTORIAL VIDEO/i.test(section.textContent || "")) {
        section.remove();
      }
    });
  };

  normalizeHomepage();

  document.addEventListener("click", (event) => {
    const card = event.target.closest("[data-routine-card-url]");
    if (!card) return;

    const routineUrl = card.getAttribute("data-routine-card-url");
    if (!routineUrl) return;

    event.preventDefault();
    event.stopPropagation();
    window.location.href = routineUrl;
  }, true);

	  const configureHeroVideoPlayback = () => {
	    if (!isHomepagePath()) return;
	
	    const video = document.querySelector("[data-hero-video], .hero-video-card video");
	    if (!video) return;
	
	    const targetVolume = 0.7;
	    let soundToggle = document.querySelector("[data-hero-sound-toggle]");
	    if (!soundToggle && video.parentElement) {
	      soundToggle = document.createElement("button");
	      soundToggle.className = "hero-sound-toggle";
	      soundToggle.type = "button";
	      soundToggle.dataset.heroSoundToggle = "";
	      soundToggle.setAttribute("aria-pressed", "false");
	      soundToggle.textContent = "Sound on";
	      video.parentElement.appendChild(soundToggle);
	    }

	    const syncSoundControl = (soundOn) => {
	      video.volume = targetVolume;
	      video.muted = !soundOn;
	      video.defaultMuted = !soundOn;
	      video.dataset.soundState = soundOn ? "on" : "muted";
	      if (soundOn) {
	        video.removeAttribute("muted");
	      } else {
	        video.setAttribute("muted", "");
	      }
	      if (soundToggle) {
	        soundToggle.hidden = false;
	        soundToggle.textContent = soundOn ? "Sound on" : "Tap for sound";
	        soundToggle.setAttribute("aria-pressed", String(soundOn));
	      }
	    };

	    video.volume = targetVolume;
	    video.autoplay = true;
	    video.loop = false;
	    video.playsInline = true;
	    video.preload = "auto";
	    video.setAttribute("autoplay", "");
	    video.setAttribute("playsinline", "");
	    video.removeAttribute("loop");
	    syncSoundControl(true);
	
	    if (video.dataset.heroPlaybackConfigured === "true") return;
	    video.dataset.heroPlaybackConfigured = "true";
	
	    const interactionEvents = ["pointerdown", "click", "touchstart", "keydown"];
	    const removeInteractionListeners = () => {
	      interactionEvents.forEach((eventName) => {
	        document.removeEventListener(eventName, startOnInteraction, { capture: true });
	      });
	    };
	
	    const tryPlay = (eventName = "load", preferSound = true) => {
	      if (video.dataset.heroPlayedOnce === "true") {
	        removeInteractionListeners();
	        return;
	      }
	
	      video.loop = false;
	      video.autoplay = true;
	      video.playsInline = true;
	      video.preload = "auto";
	      video.setAttribute("autoplay", "");
	      video.setAttribute("playsinline", "");
	      video.removeAttribute("loop");
	      syncSoundControl(preferSound);
	
	      if (video.dataset.heroAutoplayStarted !== "true") {
	        video.dataset.heroAutoplayStarted = "true";
	        video.dataset.heroAutoplayEvent = eventName;
	      }

      const playAttempt = video.play();
	      if (playAttempt && typeof playAttempt.then === "function") {
	        playAttempt
	          .then(() => {
	            video.setAttribute("data-autoplay-started", "true");
	            if (!video.muted) removeInteractionListeners();
	          })
	          .catch((error) => {
	            video.setAttribute("data-autoplay-blocked", error.name || "blocked");
	            if (preferSound) {
	              video.dataset.heroAutoplayMutedFallback = "true";
	              tryPlay("muted-fallback", false);
	              return;
	            }
	            video.dataset.heroAutoplayStarted = "false";
	          });
	        return;
	      }
	
	      video.setAttribute("data-autoplay-started", "true");
	      if (!video.muted) removeInteractionListeners();
	    };

	    const enableSound = (eventName = "interaction") => {
	      syncSoundControl(true);
	      video.dataset.heroSoundEvent = eventName;
	      const playAttempt = video.play();
	      if (playAttempt && typeof playAttempt.then === "function") {
	        playAttempt
	          .then(() => {
	            video.setAttribute("data-sound-enabled", "true");
	            removeInteractionListeners();
	          })
	          .catch((error) => {
	            video.setAttribute("data-sound-blocked", error.name || "blocked");
	            syncSoundControl(false);
	          });
	      } else {
	        video.setAttribute("data-sound-enabled", "true");
	        removeInteractionListeners();
	      }
	    };
	
	    const startOnInteraction = (event) => {
	      if (soundToggle && event.target === soundToggle) return;
	      enableSound(event.type);
	    };

	    soundToggle?.addEventListener("click", (event) => {
	      event.preventDefault();
	      event.stopPropagation();
	      if (video.muted) {
	        enableSound("button");
	      } else {
	        syncSoundControl(false);
	      }
	    });
	
	    video.addEventListener("ended", () => {
	      video.dataset.heroPlayedOnce = "true";
	      removeInteractionListeners();
	    }, { once: true });

    if (video.dataset.heroPlayedOnce === "true") {
      removeInteractionListeners();
	      return;
	    }
	
	    tryPlay("load", true);
	    video.addEventListener("loadeddata", () => tryPlay("loadeddata", !video.dataset.heroAutoplayMutedFallback), { once: true });
	    video.addEventListener("canplay", () => tryPlay("canplay", !video.dataset.heroAutoplayMutedFallback), { once: true });
	
	    interactionEvents.forEach((eventName) => {
	      document.addEventListener(eventName, startOnInteraction, { capture: true, passive: true });
	    });
	  };

  configureHeroVideoPlayback();
  document.addEventListener("DOMContentLoaded", configureHeroVideoPlayback);
  window.addEventListener("load", configureHeroVideoPlayback);
  window.setTimeout(configureHeroVideoPlayback, 1000);

  const repairEarInfectionPdfPage = () => {
    const normalizedPath = window.location.pathname.replace(/\/$/, "");
    const isEarInfectionPdfPage =
      normalizedPath.endsWith("/pages/ear-infection-research-pdf") ||
      normalizedPath.endsWith("/pages/ear-infections-lifespanning-magazine-pdf");
    if (!isEarInfectionPdfPage) return;

    const article = document.querySelector(".authority-article-main");
    if (!article || article.querySelector(".authority-pdf-source-content")) {
      document
        .querySelectorAll(".authority-article-body[data-scroll-reveal], .authority-article-main-pdf[data-scroll-reveal], .authority-pdf-pages[data-scroll-reveal]")
        .forEach((node) => {
          node.classList.add("is-scroll-revealed");
          node.dataset.scrollRevealComplete = "true";
        });
      return;
    }

    if (!article.querySelector(".authority-source-byline") && !article.querySelector(".authority-source-content h3")) return;

    const assetUrl = (filename) => {
      const assetSource =
        document.currentScript?.src ||
        document.querySelector('script[src*="/assets/theme.js"]')?.src ||
        document.querySelector('link[href*="/assets/theme.css"]')?.href;
      if (!assetSource) return `/cdn/shop/t/15/assets/${filename}`;

      return assetSource
        .replace(/theme\.(js|css).*$/, filename)
        .replace(/(\.jpg).*$/, "$1");
    };

    if (!document.getElementById("cns-ear-pdf-repair-style")) {
      const style = document.createElement("style");
      style.id = "cns-ear-pdf-repair-style";
      style.textContent = [
        ".authority-article-layout-pdf{grid-template-columns:minmax(0,1fr);max-width:1180px;}",
        ".authority-article-main-pdf{gap:20px;border:0;background:transparent;box-shadow:none;padding:0;}",
        ".authority-article-layout-pdf .authority-article-note{position:static;max-width:820px;}",
        ".authority-pdf-source-content{display:grid;gap:18px;margin-top:0;padding-top:0;border-top:0;}",
        ".authority-pdf-source-content .authority-source-disclaimer,.authority-pdf-source-content .authority-source-footnote{max-width:min(100%,920px);}",
        ".authority-pdf-pages{display:grid;gap:clamp(18px,3vw,28px);}",
        ".authority-pdf-page{overflow:hidden;margin:0;border:1px solid rgba(31,103,101,.16);border-radius:8px;background:#fff;box-shadow:0 18px 46px rgba(17,44,43,.08);}",
        ".authority-pdf-page img{display:block;width:100%;height:auto;background:#fff;}"
      ].join("");
      document.head.appendChild(style);
    }

    const pages = Array.from({ length: 13 }, (_, index) => {
      const pageNumber = String(index + 1).padStart(2, "0");
      const imageUrl = assetUrl(`ear-infections-lifespanning-page-${pageNumber}.jpg`);
      return `<figure class="authority-pdf-page"><img src="${imageUrl}" alt="Ear Infections LifeSpanning PDF page ${index + 1}" loading="eager" width="1530" height="1980"></figure>`;
    }).join("");

    article.closest(".authority-article-layout")?.classList.add("authority-article-layout-pdf");
    article.classList.add("authority-article-main-pdf");
    article.innerHTML = `
      <div class="authority-source-content authority-pdf-source-content">
        <p class="eyebrow">Original PDF pages</p>
        <h2>Ear Infections - LifeSpanning Magazine</h2>
        <p class="authority-source-disclaimer"><strong>Disclaimer:</strong> This page is provided for source review and educational context only. It is not medical advice, does not diagnose, treat, cure, or prevent disease, and should not replace guidance from a qualified healthcare professional.</p>
        <div class="authority-pdf-pages" aria-label="Rendered PDF pages from Ear Infections - LifeSpanning Magazine">${pages}</div>
        <p class="authority-source-footnote"><a href="https://drive.google.com/file/d/1eBpY2O2pVFwPtWCaBzz7mKgYAiRyKxZb/view?usp=drivesdk" target="_blank" rel="noopener">Open the original PDF source</a></p>
      </div>
    `;
  };

  repairEarInfectionPdfPage();
  document.addEventListener("DOMContentLoaded", repairEarInfectionPdfPage);
  window.addEventListener("load", repairEarInfectionPdfPage);

  const repairEczemaTherapyPage = () => {
    const normalizedPath = window.location.pathname.replace(/\/$/, "");
    if (!normalizedPath.endsWith("/pages/eczema-therapy")) return;

    const assetUrl = (filename) => {
      const assetSource =
        document.currentScript?.src ||
        document.querySelector('script[src*="/assets/theme.js"]')?.src ||
        document.querySelector('link[href*="/assets/theme.css"]')?.href;
      if (!assetSource) return `/cdn/shop/t/17/assets/${filename}`;

      return assetSource
        .replace(/theme\.(js|css).*$/, filename)
        .replace(/(\.jpg).*$/, "$1");
    };

    const pdfRenderContent = document.querySelector(".pdf-render-content");
    if (pdfRenderContent) {
      const documents = Array.from(pdfRenderContent.querySelectorAll(":scope > .pdf-render-document"));
      const introDocument = documents.find((documentNode) => documentNode.textContent.includes("SC Eczema Therapy Intro Info"));
      const reportDocument = documents.find((documentNode) => documentNode.textContent.includes("Eczema Therapy Report"));
      if (introDocument && reportDocument && reportDocument.compareDocumentPosition(introDocument) & Node.DOCUMENT_POSITION_FOLLOWING) {
        pdfRenderContent.insertBefore(introDocument, reportDocument);
      }
      return;
    }

    const article = document.querySelector(".authority-article-main");
    if (!article || article.querySelector(".authority-pdf-source-content")) {
      document
        .querySelectorAll(".authority-article-body[data-scroll-reveal], .authority-article-main-pdf[data-scroll-reveal], .authority-pdf-pages[data-scroll-reveal]")
        .forEach((node) => {
          node.classList.add("is-scroll-revealed");
          node.dataset.scrollRevealComplete = "true";
        });
      return;
    }

    const reportPages = Array.from({ length: 7 }, (_, index) => {
      const pageNumber = String(index + 1).padStart(2, "0");
      const imageUrl = assetUrl(`eczema-therapy-report-page-${pageNumber}.jpg`);
      return `<figure class="authority-pdf-page"><img src="${imageUrl}" alt="Eczema Therapy Report PDF page ${index + 1}" loading="eager" width="1530" height="1980"></figure>`;
    }).join("");

    article.closest(".authority-article-layout")?.classList.add("authority-article-layout-pdf");
    article.classList.add("authority-article-main-pdf");
    article.innerHTML = `
      <div class="authority-source-content authority-pdf-source-content">
        <p class="authority-source-disclaimer"><strong>Disclaimer:</strong> This page is provided for source review and educational context only. It is not medical advice, does not diagnose, treat, cure, or prevent disease, and should not replace guidance from a qualified healthcare professional.</p>
        <h2>SC Eczema Therapy Intro Info</h2>
        <div class="authority-pdf-pages" aria-label="Rendered PDF pages for SC Eczema Therapy Intro Info">
          <figure class="authority-pdf-page"><img src="${assetUrl("eczema-therapy-intro-page-01.jpg")}" alt="SC Eczema Therapy Intro Info PDF page 1" loading="eager" width="1530" height="1980"></figure>
        </div>
        <h2>Eczema Therapy Report</h2>
        <div class="authority-pdf-pages" aria-label="Rendered PDF pages for Eczema Therapy Report">${reportPages}</div>
      </div>
    `;
  };

  repairEczemaTherapyPage();
  document.addEventListener("DOMContentLoaded", repairEczemaTherapyPage);
  window.addEventListener("load", repairEczemaTherapyPage);

  const toggle = document.querySelector(".nav-toggle");
  const nav = document.querySelector("#PrimaryNavigation");

  if (toggle && nav) {
    toggle.addEventListener("click", () => {
      const isOpen = nav.classList.toggle("is-open");
      toggle.setAttribute("aria-expanded", String(isOpen));
    });
  }

  document.querySelectorAll("[data-product-form]").forEach((form) => {
    const selector = form.querySelector("select[name='id']");
    const prices = Array.from(document.querySelectorAll("[data-product-price]"));
    const submits = Array.from(document.querySelectorAll("[data-product-submit]"));

    if (!selector || prices.length === 0 || submits.length === 0) return;

    selector.addEventListener("change", () => {
      const option = selector.selectedOptions[0];
      const available = option?.dataset.available === "true";

      if (option?.dataset.price) {
        prices.forEach((price) => {
          price.textContent = option.dataset.price;
        });
      }
      submits.forEach((submit) => {
        submit.disabled = !available;
        submit.textContent = available ? (submit.dataset.productSubmitLabel || "Add to cart") : "Unavailable";
      });
    });
  });

	  document.querySelectorAll("[data-product-gallery]").forEach((gallery) => {
    const mainImage = gallery.querySelector("[data-product-main-image]");
    const thumbScroller = gallery.querySelector("[data-product-thumbnail-carousel]");
    const thumbs = Array.from(gallery.querySelectorAll("[data-gallery-image]"));
    const prevButton = gallery.querySelector("[data-gallery-prev]");
    const nextButton = gallery.querySelector("[data-gallery-next]");
    if (!mainImage || !thumbScroller || thumbs.length === 0) return;

    thumbs.forEach((thumb, index) => {
      thumb.dataset.galleryIndex = String(index);
      thumb.removeAttribute("data-gallery-clone");
    });

    let scrollFrame = 0;

    const clampIndex = (index) => Math.max(0, Math.min(index, thumbs.length - 1));
    const getThumbIndex = (thumb) => clampIndex(Number(thumb.dataset.galleryIndex || 0));
    const getActiveIndex = () => clampIndex(thumbs.findIndex((thumb) => thumb.classList.contains("is-active")));

    const markActive = (activeThumb) => {
      thumbs.forEach((button) => {
        button.classList.remove("is-active");
        button.removeAttribute("aria-current");
      });
      activeThumb.classList.add("is-active");
      activeThumb.setAttribute("aria-current", "true");
    };

    const activateThumb = (thumb, scrollIntoView = false) => {
      if (!thumb) return;
      const nextImage = thumb.dataset.galleryImage;
      if (!nextImage) return;

      mainImage.src = nextImage;
      mainImage.removeAttribute("srcset");
      if (thumb.dataset.galleryAlt) mainImage.alt = thumb.dataset.galleryAlt;
      markActive(thumb);
      if (scrollIntoView) thumb.scrollIntoView({ behavior: "smooth", inline: "center", block: "nearest" });
    };

    const activateIndex = (index, scrollIntoView = true) => {
      activateThumb(thumbs[clampIndex(index)], scrollIntoView);
    };

    const activateClosestVisibleThumb = () => {
      const scrollerCenter = thumbScroller.scrollLeft + thumbScroller.clientWidth / 2;
      const closestThumb = thumbs.reduce((closest, thumb) => {
        const thumbCenter = thumb.offsetLeft + thumb.offsetWidth / 2;
        const closestCenter = closest.offsetLeft + closest.offsetWidth / 2;
        return Math.abs(thumbCenter - scrollerCenter) < Math.abs(closestCenter - scrollerCenter) ? thumb : closest;
      }, thumbs[0]);

      activateThumb(closestThumb, false);
    };

    const scheduleScrollSync = () => {
      window.cancelAnimationFrame(scrollFrame);
      scrollFrame = window.requestAnimationFrame(activateClosestVisibleThumb);
    };

    thumbScroller.addEventListener("click", (event) => {
      const thumb = event.target.closest("[data-gallery-image]");
      if (thumb && thumbScroller.contains(thumb)) activateThumb(thumb, true);
    });

    thumbScroller.addEventListener("scroll", scheduleScrollSync, { passive: true });

    thumbScroller.addEventListener("wheel", (event) => {
      if (Math.abs(event.deltaY) <= Math.abs(event.deltaX)) return;
      event.preventDefault();
      thumbScroller.scrollLeft += event.deltaY;
      scheduleScrollSync();
    }, { passive: false });

    const scrollThumbs = (direction) => {
      const currentIndex = getActiveIndex();
      activateIndex(currentIndex + direction, true);
    };

    prevButton?.addEventListener("click", () => scrollThumbs(-1));
    nextButton?.addEventListener("click", () => scrollThumbs(1));

	    window.requestAnimationFrame(() => activateIndex(0, false));
	  });

	  const resetRetailAccordions = () => {
	    document.querySelectorAll(".retail-accordion details.retail-province").forEach((details) => {
	      details.removeAttribute("open");
	      details.open = false;
	    });
	  };

	  resetRetailAccordions();
	  document.addEventListener("DOMContentLoaded", resetRetailAccordions);
	  window.addEventListener("pageshow", resetRetailAccordions);
	
		  document.querySelectorAll("[data-expandable-testimonial]").forEach((card) => {
		    const toggle = card.querySelector("[data-expandable-testimonial-toggle]");
		    const content = card.querySelector("[data-expandable-testimonial-content]");
	    if (!toggle || !content || card.dataset.expandableReady === "true") return;
	    card.dataset.expandableReady = "true";
	    const reduceMotionQuery = window.matchMedia?.("(prefers-reduced-motion: reduce)");
	
	    const syncCard = (targetCard, isOpen) => {
	      const targetToggle = targetCard.querySelector("[data-expandable-testimonial-toggle]");
	      const targetContent = targetCard.querySelector("[data-expandable-testimonial-content]");
	      if (!targetToggle || !targetContent) return;
	
	      const collapsedLabel = targetToggle.dataset.collapsedLabel || "Read more";
	      const expandedLabel = targetToggle.dataset.expandedLabel || "Show less";
	      targetCard.classList.toggle("is-expanded", isOpen);
	      targetToggle.setAttribute("aria-expanded", String(isOpen));
	      targetToggle.textContent = isOpen ? expandedLabel : collapsedLabel;
	      targetContent.hidden = !isOpen;
	    };

	    const returnToCollapsedView = (target) => {
	      const section = target.closest(".source-testimonials-section") || target;
	      const header = document.querySelector(".site-header");
	      const headerHeight = header ? header.getBoundingClientRect().height : 0;

	      window.requestAnimationFrame(() => {
	        const rect = section.getBoundingClientRect();
	        const offset = headerHeight + 18;
	        const top = Math.max(window.scrollY + rect.top - offset, 0);
	        const needsScroll = rect.top < offset || rect.top > window.innerHeight * 0.42;

	        if (!needsScroll) return;
	        window.scrollTo({
	          top,
	          behavior: reduceMotionQuery?.matches ? "auto" : "smooth"
	        });
	      });
	    };
	
		    toggle.addEventListener("click", () => {
		      const isOpen = toggle.getAttribute("aria-expanded") === "true";
		      const nextOpen = !isOpen;
		      const group = card.closest("[data-expandable-testimonial-group]");
		      if (group && nextOpen) {
		        Array.from(group.querySelectorAll("[data-expandable-testimonial]")).forEach((targetCard) => {
		          if (targetCard !== card) syncCard(targetCard, false);
		        });
		      }
		
		      syncCard(card, nextOpen);
		      if (!nextOpen) returnToCollapsedView(group || card);
		    });
		  });

	  const initScrollReveal = () => {
	    const reduceMotionQuery = window.matchMedia?.("(prefers-reduced-motion: reduce)");
	    const revealSelectors = [
	      "main > section",
	      ".hero-copy > *",
	      ".hero-video-card",
	      ".section-heading",
	      ".retail-teaser-grid > *",
	      ".category-card",
	      ".category-products a",
	      ".product-card",
	      ".product-media-panel",
	      ".product-info-panel",
	      ".product-purchase-panel",
	      ".product-detail-panel",
	      ".routine-pairing-card",
	      ".routine-product-link",
	      ".free-shipping-grid > *",
	      ".free-shipping-products .routine-product-link",
	      ".ultimate-routine-banner",
	      ".ultimate-routine-item",
	      ".video-intro-card",
	      ".retail-locations-card",
	      ".education-directory-intro",
	      ".education-card",
	      ".education-detail",
	      ".routine-detail-card",
	      ".retail-directory-intro",
	      ".retail-province",
	      ".retail-location-grid > *",
	      ".authority-card",
	      ".source-testimonial-card",
	      ".testimonial-card",
	      ".trust-points > div",
	      ".contact-strip > *",
	      ".product-template > *",
	      ".authority-article-main",
	      ".authority-article-note",
	      ".authority-source-content > *",
	      ".pdf-render-document",
	      ".cart-line",
	      ".cart-summary",
	      ".empty-state"
	    ];
	    const selector = revealSelectors.join(",");
	    const candidates = Array.from(document.querySelectorAll(selector)).filter((node) => {
	      if (!(node instanceof HTMLElement)) return false;
	      if (node.hidden || node.closest("[hidden]")) return false;
	      if (node.dataset.carouselClone === "true" || node.closest("[data-carousel-clone='true']")) return false;
	      if (node.closest(".chatbot-panel")) return false;
	      return true;
	    });

	    if (candidates.length === 0) return;

	    const revealCompleteDelay = 660;
	    const markRevealed = (node) => {
	      node.classList.add("is-scroll-revealed");
	      window.setTimeout(() => {
	        node.dataset.scrollRevealComplete = "true";
	      }, revealCompleteDelay);
	    };

	    const markIfLargeVisibleSection = (node) => {
	      const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
	      if (!viewportHeight) return false;
	      const rect = node.getBoundingClientRect();
	      const intersectsViewport = rect.bottom > 0 && rect.top < viewportHeight;
	      const isLargeSection = node.matches("main > section, .section") && rect.height > viewportHeight * 1.15;
	      if (!intersectsViewport || !isLargeSection) return false;
	      markRevealed(node);
	      return true;
	    };
	
	    const revealAll = () => {
	      candidates.forEach((node) => {
	        node.dataset.scrollReveal = "ready";
	        node.dataset.scrollRevealComplete = "true";
	        node.classList.add("is-scroll-revealed");
	      });
	    };

	    if (reduceMotionQuery?.matches || !("IntersectionObserver" in window)) {
	      revealAll();
	      return;
	    }

	    document.body.classList.add("scroll-reveal-ready");
	    candidates.forEach((node, index) => {
	      node.dataset.scrollReveal = "ready";
	      node.style.setProperty("--reveal-delay", `${Math.min(index % 5, 4) * 45}ms`);
	    });

	    const observer = new IntersectionObserver((entries) => {
	      entries.forEach((entry) => {
	        if (!entry.isIntersecting) return;
	        markRevealed(entry.target);
	        observer.unobserve(entry.target);
	      });
	    }, {
	      rootMargin: "0px 0px -5% 0px",
	      threshold: 0.01
	    });

	    candidates.forEach((node) => {
	      if (!markIfLargeVisibleSection(node)) observer.observe(node);
	    });
	  };

	  initScrollReveal();

  document.querySelectorAll("[data-testimonial-carousel-shell]").forEach((shell) => {
    const carousel = shell.querySelector("[data-testimonial-carousel]");
    const track = shell.querySelector(".testimonial-track");
    const cards = Array.from(shell.querySelectorAll(".testimonial-card")).filter((card) => card.dataset.carouselClone !== "true");
    const prevButton = shell.querySelector("[data-testimonial-prev]");
    const nextButton = shell.querySelector("[data-testimonial-next]");
    if (!carousel || !track || cards.length < 2) return;
    if (shell.dataset.carouselInfiniteReady === "true") return;
    shell.dataset.carouselInfiniteReady = "true";

	    const makeCarouselClone = (card, clonePosition) => {
	      const clone = card.cloneNode(true);
	      clone.dataset.carouselClone = "true";
	      clone.dataset.carouselClonePosition = clonePosition;
	      clone.removeAttribute("data-scroll-reveal");
	      clone.classList.remove("is-scroll-revealed");
	      clone.style.removeProperty("--reveal-delay");
	      clone.style.removeProperty("will-change");
	      clone.setAttribute("aria-hidden", "true");
      clone.querySelectorAll("a, button, input, select, textarea, [tabindex]").forEach((node) => {
        node.setAttribute("tabindex", "-1");
      });
      return clone;
    };

    const leadingClones = document.createDocumentFragment();
    const trailingClones = document.createDocumentFragment();
    cards.forEach((card) => {
      leadingClones.appendChild(makeCarouselClone(card, "before"));
      trailingClones.appendChild(makeCarouselClone(card, "after"));
    });
    track.insertBefore(leadingClones, track.firstChild);
    track.appendChild(trailingClones);

	    carousel.classList.add("is-ready");
	    shell.classList.add("is-infinite");
	    shell.classList.add("is-smooth-loop");
	    carousel.setAttribute("aria-live", "off");
	    let dragging = false;
	    let startX = 0;
	    let startOffset = 0;
	    let currentOffset = 0;
	    let animationFrame = 0;
	    let nudgeFrame = 0;
	    let lastFrameTime = 0;
	    let pauseUntil = 0;
	    const reduceCarouselMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
	    const loopPixelsPerSecond = 28;
	    const interactionResumeDelay = 900;
	    const nudgeDuration = 460;

    const getCardStep = () => {
      const firstCard = cards[0];
      const trackStyles = window.getComputedStyle(track);
      const gap = parseFloat(trackStyles.columnGap || trackStyles.gap || 0) || 0;
      return firstCard.getBoundingClientRect().width + gap;
    };

	    const hasScrollableReviews = () => track.scrollWidth > carousel.clientWidth + 8;

    const getLoopBounds = () => {
      const firstOriginal = cards[0];
      const firstTrailingClone = track.querySelector('[data-carousel-clone-position="after"]');
      const start = firstOriginal?.offsetLeft || 0;
      const end = firstTrailingClone?.offsetLeft || carousel.scrollWidth;
      return {
        start,
        end,
        segmentWidth: Math.max(0, end - start)
      };
    };

	    const normalizeOffset = () => {
	      const { start, end, segmentWidth } = getLoopBounds();
	      if (!segmentWidth) return;
	      while (currentOffset < start) currentOffset += segmentWidth;
	      while (currentOffset >= end) currentOffset -= segmentWidth;
	    };

	    const renderOffset = () => {
	      normalizeOffset();
	      track.style.transform = `translate3d(${-currentOffset}px, 0, 0)`;
	    };

    const updateButtons = () => {
      const scrollable = hasScrollableReviews();
      shell.classList.toggle("is-at-start", false);
      shell.classList.toggle("is-at-end", false);
      if (prevButton) prevButton.disabled = !scrollable;
      if (nextButton) nextButton.disabled = !scrollable;
    };

	    const pauseLoopBriefly = (delay = interactionResumeDelay) => {
	      pauseUntil = Date.now() + delay;
	      lastFrameTime = 0;
	    };

	    const animateNudge = (direction) => {
	      if (!hasScrollableReviews()) return;
	      window.cancelAnimationFrame(nudgeFrame);
	      const fromOffset = currentOffset;
	      const toOffset = currentOffset + direction * getCardStep();
	      const startedAt = performance.now();
	      pauseLoopBriefly(nudgeDuration + 140);

	      const stepNudge = (timestamp) => {
	        const progress = Math.min((timestamp - startedAt) / nudgeDuration, 1);
	        const easedProgress = 1 - Math.pow(1 - progress, 3);
	        currentOffset = fromOffset + (toOffset - fromOffset) * easedProgress;
	        renderOffset();

	        if (progress < 1) {
	          nudgeFrame = window.requestAnimationFrame(stepNudge);
	          return;
	        }

	        pauseLoopBriefly();
	      };

	      nudgeFrame = window.requestAnimationFrame(stepNudge);
	    };

	    const runLoop = (timestamp) => {
	      animationFrame = window.requestAnimationFrame(runLoop);
	      if (reduceCarouselMotion || document.hidden || dragging || !hasScrollableReviews()) {
	        lastFrameTime = timestamp;
	        return;
	      }
	      if (Date.now() < pauseUntil) {
	        lastFrameTime = timestamp;
	        return;
	      }
	      if (!lastFrameTime) {
	        lastFrameTime = timestamp;
	        return;
	      }

	      const elapsed = Math.min(timestamp - lastFrameTime, 64);
	      lastFrameTime = timestamp;
	      currentOffset += (loopPixelsPerSecond * elapsed) / 1000;
	      renderOffset();
	      updateButtons();
	    };

	    prevButton?.addEventListener("click", () => animateNudge(-1));
	    nextButton?.addEventListener("click", () => animateNudge(1));

		    carousel.addEventListener("wheel", (event) => {
		      const wheelDelta = Math.abs(event.deltaX) > Math.abs(event.deltaY) ? event.deltaX : event.deltaY;
		      if (!wheelDelta) return;
		      event.preventDefault();
		      pauseLoopBriefly();
		      currentOffset += wheelDelta;
		      renderOffset();
		      updateButtons();
		    }, { passive: false });

	    const stopDragging = () => {
	      dragging = false;
	      carousel.classList.remove("is-dragging");
	      pauseLoopBriefly();
	      updateButtons();
	    };

	    carousel.addEventListener("pointerdown", (event) => {
	      dragging = true;
	      pauseLoopBriefly();
	      startX = event.clientX;
	      startOffset = currentOffset;
	      carousel.classList.add("is-dragging");
	      carousel.setPointerCapture?.(event.pointerId);
	    });

	    carousel.addEventListener("pointermove", (event) => {
	      if (!dragging) return;
	      currentOffset = startOffset - (event.clientX - startX);
	      renderOffset();
	      updateButtons();
	    });

	    carousel.addEventListener("pointerup", stopDragging);
	    carousel.addEventListener("pointercancel", stopDragging);
	    window.addEventListener("resize", () => {
	      renderOffset();
	      updateButtons();
	    });

	    window.requestAnimationFrame(() => {
	      currentOffset = getLoopBounds().start;
	      carousel.scrollLeft = 0;
	      renderOffset();
	      shell.classList.add("is-infinite-ready");
	      updateButtons();
	      animationFrame = window.requestAnimationFrame(runLoop);
	    });
  });

  const updateChatbotOffset = () => {
    const previewBar = document.querySelector("#PBarNextFrameWrapper");
    const rect = previewBar?.getBoundingClientRect();
    const barHeight = rect && rect.height > 0 && rect.top < window.innerHeight ? Math.ceil(window.innerHeight - rect.top) : 0;
    const stickyCart = document.querySelector(".mobile-sticky-cart");
    const stickyCartStyle = stickyCart ? window.getComputedStyle(stickyCart) : null;
    const stickyCartRect = stickyCart?.getBoundingClientRect();
    const stickyCartVisible = stickyCartStyle && stickyCartStyle.display !== "none" && stickyCartRect && stickyCartRect.height > 0;
    document.documentElement.classList.toggle("has-mobile-sticky-cart", Boolean(stickyCartVisible));
    const stickyCartHeight = stickyCartVisible ? Math.ceil(stickyCartRect.height) : 0;
    const totalFixedHeight = barHeight + stickyCartHeight;
    const offset = totalFixedHeight > 0 ? `${totalFixedHeight + 18}px` : "";
    if (offset) {
      document.documentElement.style.setProperty("--chatbot-bottom-offset", offset);
    } else {
      document.documentElement.style.removeProperty("--chatbot-bottom-offset");
    }
  };

  updateChatbotOffset();
  window.addEventListener("resize", updateChatbotOffset);
  window.setTimeout(updateChatbotOffset, 400);
  window.setTimeout(updateChatbotOffset, 1200);

  if (!document.querySelector("[data-company-chatbot]")) {
    const fallback = document.createElement("div");
    fallback.className = "company-chatbot";
    fallback.dataset.companyChatbot = "";
    fallback.innerHTML = `
      <button class="chatbot-toggle" type="button" data-chatbot-toggle aria-expanded="false" aria-controls="CompanyChatbotPanel">
        <span class="chatbot-toggle-icon" aria-hidden="true">?</span>
        <span>Product help</span>
      </button>
      <section id="CompanyChatbotPanel" class="chatbot-panel" data-chatbot-panel aria-label="Canada Nano Silver product assistant" hidden style="display: none;">
        <header class="chatbot-header">
          <div>
            <p class="eyebrow">Canada Nano Silver assistant</p>
            <h2>Ask about our products</h2>
          </div>
          <button class="chatbot-close" type="button" data-chatbot-close aria-label="Close product assistant">&times;</button>
        </header>
        <div class="chatbot-messages" data-chatbot-messages aria-live="polite">
          <div class="chatbot-message chatbot-message-bot">
            I can help with Canada Nano Silver products, categories, routines, retail locations, checkout, shipping, and support. I cannot answer unrelated questions.
          </div>
        </div>
        <div class="chatbot-suggestions" aria-label="Suggested questions">
          <button type="button" data-chatbot-suggestion="What categories can I shop?">Categories</button>
          <button type="button" data-chatbot-suggestion="Which routine should I browse?">Routines</button>
          <button type="button" data-chatbot-suggestion="Where can I find retail locations?">Retail locations</button>
        </div>
        <form class="chatbot-form" data-chatbot-form>
          <label class="visually-hidden" for="CompanyChatbotInput">Ask about Canada Nano Silver products</label>
          <input id="CompanyChatbotInput" data-chatbot-input type="text" autocomplete="off" placeholder="Ask about products or routines">
          <button class="button button-primary" type="submit">Send</button>
        </form>
      </section>
    `;
    document.body.appendChild(fallback);
  }

  document.querySelectorAll("[data-company-chatbot]").forEach((chatbot) => {
    if (chatbot.dataset.chatbotReady === "true") return;
    chatbot.dataset.chatbotReady = "true";

    const toggle = chatbot.querySelector("[data-chatbot-toggle]");
    const close = chatbot.querySelector("[data-chatbot-close]");
    const panel = chatbot.querySelector("[data-chatbot-panel]");
    const form = chatbot.querySelector("[data-chatbot-form]");
    const input = chatbot.querySelector("[data-chatbot-input]");
    const messages = chatbot.querySelector("[data-chatbot-messages]");
    const suggestions = Array.from(chatbot.querySelectorAll("[data-chatbot-suggestion]"));

    if (!toggle || !panel || !form || !input || !messages) return;

    const allowedTerms = [
      "canada nano silver",
      "silver biotics",
      "silverceuticals",
      "product",
      "products",
      "category",
      "categories",
      "routine",
      "routines",
      "kit",
      "kits",
      "bundle",
      "bundles",
      "immune",
      "daily defense",
      "silver",
      "lozenge",
      "lozenges",
      "gummy",
      "gummies",
      "oral",
      "tooth",
      "toothpaste",
      "tooth gel",
      "skin",
      "first aid",
      "gel",
      "cream",
      "face",
      "facial",
      "serum",
      "mister",
      "roller",
      "sinus",
      "book",
      "accessories",
      "retail",
      "retailer",
      "location",
      "locations",
      "shipping",
      "checkout",
      "canada",
      "support",
      "contact",
      "price",
      "shop",
      "benefit",
      "benefits"
    ];

    const outOfScopeTerms = [
      "diagnose",
      "diagnosis",
      "treat",
      "treatment",
      "cure",
      "disease",
      "prescription",
      "medicine",
      "medical advice",
      "doctor",
      "law",
      "legal",
      "investment",
      "politics",
      "weather",
      "news",
      "homework",
      "code",
      "programming",
      "recipe"
    ];

    const categories = [
      "Immune & Daily Defense: daily immune support supplement, immune gummies, four Silver Biotics lozenge flavors, sinus relief spray, and trace element supplements.",
      "Oral Care: Active Defense toothpaste, Silver Biotics Tooth Gel, and Tooth Paste Winter Mint.",
      "Skin Recovery & First Aid: antimicrobial skin cream, nano-silver gel, wound dressing gel, eczema therapy, and muscle cream.",
      "Face Care & Tools: facial serums, Nano Mister, and Tube Roller.",
      "Learning & Accessories: Nature's Natural Healer book and product tools."
    ];

    const routines = [
      "Daily Immune Defense Kit: supplement, immune gummies, and selectable Silver Biotics lozenge flavors.",
      "Complete Oral Care Routine Kit: toothpaste, tooth gel, and Winter Mint toothpaste.",
      "Skin Recovery Essentials Kit: antimicrobial skin cream, nano-silver gel, and wound dressing gel.",
      "Radiant Face & Hydration Kit: facial serums, Nano Mister, and Tube Roller."
    ];

    const guardrail = "I can only help with Canada Nano Silver products, product categories, routines, retail locations, shipping, checkout, and support. I cannot answer unrelated questions or provide medical, legal, financial, or general advice.";

    const addMessage = (text, type = "bot") => {
      const node = document.createElement("div");
      node.className = `chatbot-message chatbot-message-${type}`;
      node.textContent = text;
      messages.appendChild(node);
      messages.scrollTop = messages.scrollHeight;
    };

    const isAllowed = (question) => {
      const normalized = question.toLowerCase();
      if (outOfScopeTerms.some((term) => normalized.includes(term))) return false;
      return allowedTerms.some((term) => normalized.includes(term));
    };

    const answer = (question) => {
      const normalized = question.toLowerCase();
      if (!isAllowed(question)) return guardrail;

      if (normalized.includes("category") || normalized.includes("categories") || normalized.includes("shop")) {
        return `You can shop by category: ${categories.join(" ")}`;
      }

      if (normalized.includes("routine") || normalized.includes("kit") || normalized.includes("bundle")) {
        return `Our ready-made routines are: ${routines.join(" ")} Each routine is purchasable as its own product, and individual products remain available separately.`;
      }

      if (normalized.includes("lozenge") || normalized.includes("lozenges")) {
        return "The Silver Biotics lozenges are available as separate products in Manuka Honey Mint, Honey with Nano-SilverSol, and Vitamin C Orange Splash. They also fit within the Immune & Daily Defense category and Daily Immune Defense Kit.";
      }

      if (normalized.includes("retail") || normalized.includes("location") || normalized.includes("retailer")) {
        return "Retail locations are listed by province on the Retailer Location page. Use the province dropdowns and call ahead to confirm product availability.";
      }

      if (normalized.includes("shipping") || normalized.includes("checkout") || normalized.includes("canada")) {
        return "Orders ship World Wide. Taxes and shipping are calculated at checkout, and the storefront keeps product browsing and checkout support clear.";
      }

      if (normalized.includes("contact") || normalized.includes("support")) {
        return "For support, use the store contact options, call 204-808-9292, or email info@canadananosilver.com.";
      }

      if (normalized.includes("oral") || normalized.includes("tooth")) {
        return "For oral care, browse Active Defense Toothpaste, Silver Biotics Tooth Gel, Tooth Paste Winter Mint, or the Complete Oral Care Routine Kit.";
      }

      if (normalized.includes("skin") || normalized.includes("first aid")) {
        return "For skin care and first aid browsing, view antimicrobial skin cream, nano-silver gel, wound dressing gel, eczema therapy, muscle cream, or the Skin Recovery Essentials Kit.";
      }

      if (normalized.includes("face") || normalized.includes("facial") || normalized.includes("serum") || normalized.includes("mister") || normalized.includes("roller")) {
        return "For face care and tools, browse facial serums, the Nano Mister, Tube Roller, or the Radiant Face & Hydration Kit.";
      }

      if (normalized.includes("immune") || normalized.includes("daily defense")) {
        return "For Immune & Daily Defense browsing, view the daily immune support supplement, immune gummies, Honey, Manuka Honey Mint, and Orange Splash lozenges, sinus relief spray, trace element supplements, or the Daily Immune Defense Kit.";
      }

      if (normalized.includes("benefit") || normalized.includes("benefits")) {
        return "The main shopping benefits are clear categories, ready-made routines, individual product browsing, real product photos, World-Wide Shipping, local support, and province-based retail location lookup.";
      }

      return "I can help you compare Canada Nano Silver categories, routines, retail locations, shipping, checkout, and support. Try asking about oral care, immune support, skin care, face care, or retail locations.";
    };

    const open = () => {
      panel.hidden = false;
      panel.style.display = "";
      toggle.setAttribute("aria-expanded", "true");
      window.setTimeout(() => input.focus(), 40);
    };

    const hide = () => {
      panel.hidden = true;
      panel.style.display = "none";
      toggle.setAttribute("aria-expanded", "false");
      toggle.focus();
    };

    if (panel.hidden) panel.style.display = "none";

    toggle.addEventListener("click", () => {
      if (panel.hidden) open();
      else hide();
    });

    close?.addEventListener("click", hide);

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape" && !panel.hidden) hide();
    });

    suggestions.forEach((button) => {
      button.addEventListener("click", () => {
        const question = button.dataset.chatbotSuggestion || button.textContent.trim();
        input.value = question;
        addMessage(question, "user");
        addMessage(answer(question));
      });
    });

    form.addEventListener("submit", (event) => {
      event.preventDefault();
      const question = input.value.trim();
      if (!question) return;

      addMessage(question, "user");
      addMessage(answer(question));
      input.value = "";
    });
  });
})();
